<div class="o-grid u-hidden@up-to-md">
	<div class="o-grid__cell u-ost-xl">
		<list-tabs [tabs]="vm.tabs" [(activeTab)]="vm.activeTab"></list-tabs>
	</div>
</div>
<section class="c-section u-no-pb" [ngClass]="{'u-hidden@md-and-up': vm.activeTab!==$index, 'c-section--first': $index==0, 'c-section--last': $index==vm.tabs?.length-1}" *ngFor="let tab of vm.tabs ; let $index=index ; let $first = first" panel [isOpen]="$first">
	<div class="c-section__header u-hidden@md-and-up">
		<h2 class="c-section__title">{{ tab.label }}</h2>
	</div>
	<div class="c-section__content">
		<div class="o-grid">
			<div class="o-grid__cell c-cell">
				<card-consents [consentType]="tab.type"></card-consents>
			</div>
		</div>
	</div>
</section>
